import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AsciiFormatService {

  constructor(
      private http: HttpClient,
  ) { }

  extractFec$(
    remoteFileId: string
  ): Observable<Blob> {
    const url = `${environment.apiURL}/tools/ascii-format-fec-extraction`;

    return this.http.post(url, {remoteFileId}, {responseType: 'blob'});
  }
}
